<template>
  <section class="home-section home-almacenaje mb-3 mb-md-5">
    <div class="container">
      <div class="section-head mb-3">
        <div class="service-head-bg">
          <img
            src="@/assets/images/service-head-bg-1.jpg"
            alt
            class="img-fluid"
          />
        </div>
        <div class="sec-header">
          <h1 class="title"><span>1.</span> Almacenaje</h1>
          <h2 class="sec-subtitle">
            Almacenaje de mercancía de
            <br />productos en diferentes
          </h2>
          <div class="section-head-action">
            <router-link
              class="btn btn-outline-light rounded-0 font-weight-bold"
              to="/servicios"
            >
              <span>+</span> Info
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="sec-content">
        <div class="row">
          <div class="col-md-4 col-lg-4 sec-desc">
            <h2 class="sec-desc-title">El Almacen</h2>
            <h3 class="sec-desc-subtitle">es una unidad de servicio</h3>
            <p class="sec-desc-cont">
              El almacen es una unidad de servicio y soporte en la estructura
              orgánica y funcional de una compañía, comercial o industrial, con
              propósitos bien definidos de custodia, control y abastecimiento de
              materiales y productos.
              <br />En la actualidad, lo que antes se caracterizaba como un
              espacio dentro de la empresa destinado al uso exclusico de arrume
              de mercancía, es una estructura clave que provee elementos físicos
              y funcionales capaces de generar valor agregado.
            </p>
          </div>
          <div class="col-md-4 col-lg-4 sec-desc">
            <h2 class="sec-desc-title">Soluciones Específicas</h2>
            <h3 class="sec-desc-subtitle">de almanecimiento</h3>
            <p class="sec-desc-cont">
              Cada sector de actividad utiliza para el almacenaje de mercancías
              diferentes equipos de manipulación y soluciones específicas de
              almacenamiento con el fin de reducir costes y conseguir una mayor
              eficacia en el proceso de almacenaje; desde que se reciben los
              productos por parte de los proveedores hasta que los pedidos son
              servidos para enviárselos a los clientes
            </p>
          </div>
          <div class="col-md-4 col-lg-4 sec-desc">
            <div class="home-frase py-3 px-4">
              <h2 class="sec-desc-title text-primary">
                ¿Qué es la gestión de almacenes?
              </h2>
              <p class="sec-desc-cont text-white">
                La gestión de alamacenes como el preceso logístico que se
                encarga de la recepción, el almacenamieno y movimiento dentro de
                un mismo almacén hasta el punto de consumo de cualquier unidad
                logística, así como el tratamiento de informacion de los datos
                generados en cada uno de los procesos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeAlmacenaje',
}
</script>

<style lang="scss" scoped>
.home-almacenaje {
  .sec-desc-title {
    margin-bottom: 0;
    font-size: 2.7rem;
    line-height: 2.7rem;
  }
  .sec-desc-subtitle {
    font-size: 1.6rem;
    line-height: 1.6rem;
    font-weight: 200;
    margin-bottom: 1.5rem;
  }
  .home-frase {
    background-image: url('~@/assets/images/plano3.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .sec-desc-title {
      font-size: 2rem;
      line-height: 2.2rem;
    }
  }
}
</style>
